export var IMAGE_BACKGROUND_TYPE = 'image';
export var VIDEO_BACKGROUND_TYPE = 'video';
export var COVER_MIN_HEIGHT = 50;
export function backgroundImageStyles(url) {
  return url ? {
    backgroundImage: "url(".concat(url, ")")
  } : {};
}
export function dimRatioToClass(ratio) {
  return ratio === 0 || ratio === 50 ? null : 'has-background-dim-' + 10 * Math.round(ratio / 10);
}
//# sourceMappingURL=shared.js.map